import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PostContentObjectDetailDataObject } from 'models/service';

type EditPostRequestBody = {
  attachments?: Array<{ id: string }>;
  html_content: string;
  program_topic_id: string;
  publish_at: string;
  text_content?: string;
  title: string;
  todo_due_date: string;
};

export const editPost = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<EditPostRequestBody, { id: string }>) =>
  apiClient.put<PostContentObjectDetailDataObject, ApiClientResponse<PostContentObjectDetailDataObject>>(
    routes.posts.update(id),
    {
      post: body,
    },
  );
